import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Sparkles, Trophy, ArrowRight, Share2 } from "lucide-react";

export default function TestResult() {
  const { id } = useParams();
  const [r, setR] = useState(null);
  useEffect(() => { api.get(`/test-results/${id}`).then(res => setR(res.data)); }, [id]);
  if (!r) return <div className="lumina-container py-20 text-center text-[#5C5870]">Memuat…</div>;
  return (
    <div className="lumina-container py-16 max-w-3xl" data-testid="test-result-page">
      <div className="lumina-card overflow-hidden">
        <div className="bg-gradient-to-br from-[#6B4BA3] to-[#9D84D2] text-white p-10 text-center">
          <Trophy className="w-12 h-12 mx-auto mb-4 opacity-80" />
          <div className="text-xs uppercase tracking-widest opacity-80 mb-2">Hasil Tesmu</div>
          <h1 className="font-serif text-4xl mb-2">{r.tier_title}</h1>
          <p className="opacity-90">{r.test_title}</p>
          <div className="mt-6 inline-flex items-center gap-3 bg-white/20 backdrop-blur rounded-full px-6 py-2">
            <Sparkles className="w-4 h-4" /> Skor: <span className="font-bold">{r.score}</span>
          </div>
        </div>
        <div className="p-10">
          <h2 className="font-serif text-2xl text-[#1A1728] mb-4">Interpretasi</h2>
          <p className="text-[#5C5870] leading-relaxed text-lg mb-8">{r.tier_description}</p>
          {r.share_id && (
            <div className="bg-gradient-to-br from-[#E8F0FA] to-[#F1EBFA] rounded-2xl p-6 mb-6 flex flex-wrap items-center justify-between gap-4">
              <div>
                <h3 className="font-serif text-xl text-[#1A1728] mb-1">Bagikan hasilmu</h3>
                <p className="text-sm text-[#5C5870]">Card cantik siap-share di sosmed.</p>
              </div>
              <Link to={`/share/test/${r.share_id}`} className="lumina-btn-primary" data-testid="share-result-btn">
                <Share2 className="w-4 h-4" /> Buka Share Card
              </Link>
            </div>
          )}
          <div className="bg-[#E8F0FA] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-xl text-[#1A1728] mb-2">Ingin pendalaman?</h3>
            <p className="text-sm text-[#5C5870] mb-4">Konsultasikan hasilmu dengan psikolog berlisensi untuk pemahaman yang lebih dalam.</p>
            <Link to="/services" className="lumina-btn-primary inline-flex">Booking Konsultasi <ArrowRight className="w-4 h-4" /></Link>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link to="/tests" className="lumina-btn-outline">Coba Tes Lain</Link>
            <Link to="/profile" className="lumina-btn-secondary">Lihat Riwayat</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
